<template>
  <div class="publisher-associate-table">
    <div class="table-head">
      <a-space>
        <div class="actions" ref="operationRef">
          <!-- <a-dropdown
            :getPopupContainer="() => $refs.operationRef"
            trigger="click"
            @openChange="getProductVariations"
          >
            <template #overlay>
              <artmisads-dropdown-menu @click="handleMenuClick">
                <a-spin :spinning="dropDownLoading">
                  <a-menu-item
                    key="activeBrands"
                    v-if="activeSelectedRowKeys.length"
                  >
                    <div class="actions-item">
                      <span>Edit Partnered Brands</span>
                      <span class="action-num">
                        <span class="num">{{
                          activeSelectedRowKeys.length
                        }}</span>
                      </span>
                    </div>
                  </a-menu-item>
                  <a-menu-item
                    key="inactiveBrands"
                    v-if="inactiveSelectedRowKeys.length"
                  >
                    <div class="actions-item">
                      <span>Set Up Associate Partnership</span>
                      <span class="action-num">
                        <span class="num">{{
                          inactiveSelectedRowKeys.length
                        }}</span>
                      </span>
                    </div>
                  </a-menu-item>
                </a-spin>
              </artmisads-dropdown-menu>
            </template>
            <artmisads-button
              style="height: 32px; padding: 0px"
              :isSquare="true"
              class="actions-button"
              :disabled="!allSelectedRowKeys.size"
              showDownIcon="true"
              type="primary"
            >
              Actions
              <SvgIcon
                name="jiantou-xia-cu"
                class="artmisads-select-down-icon"
              />
            </artmisads-button>
          </a-dropdown> -->
        </div>
        <buttonGroups
          :pagination="{
            total: tableTotal,
            page: params.page,
            size: params.size,
          }"
          :tableData="data"
          @pageChange="handlePageChange"
        />
      </a-space>

      <a-space class="filters">
        <artmisads-select-button v-if="publisherId" @click="handleRule">
          {{ $t('seller.publishersPage.setSpecificCommissionRule') }}
        </artmisads-select-button>
        <a-input-search
          v-model:value="keyword"
          :placeholder="$t('seller.common.searchPlaceholder')"
          allow-clear
          @search="handleSearch"
          @enter="handleSearch"
        >
        </a-input-search>

        <div class="statusFilter">
          <span style="margin-right: 8px">{{ $t('seller.publishersPage.partnershipStatus') }}</span>
          <artmisads-select
            v-model:value="partnershipStatus"
            style="width: 180px"
            @change="handleStatusChange"
            trigger="click"
          >
            <a-select-option value="">{{ $t('seller.common.all') }}</a-select-option>
            <a-select-option value="active">{{ $t('seller.brandsPage.partnershipPartnered') }}</a-select-option>
            <a-select-option value="inactive">{{ $t('seller.brandsPage.partnershipNotPartnered') }}</a-select-option>
          </artmisads-select>
        </div>
      </a-space>
    </div>
    <!--  -->
    <div class="table">
      <artmisads-table
        row-key="id"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :noData="!associateEnabled"
        :scroll="{ x: 1500, y: tableScrollHeight }"
        :pagination="{
          total: tableTotal,
          current: params.page,
          pageSize: params.size,
          showTotal: (total) => $t('seller.publishersPage.paginationTotal', { total }),
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100', '200'],
        }"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :change="handleChangePage"
      >
        <template #emptyText v-if="!associateEnabled && !props.brandId">
          {{ $t('seller.publishersPage.associateNotAvailableEmpty') }}
        </template>
        <template #headerCell="{ column }" v-if="props.brandId">
          <template v-if="column.dataIndex === 'nextMonthCommission'">
            {{ column.title }}
            <a-popover placement="top">
              <template #content>
                <p>{{ $t('seller.publishersPage.modifyCommissionPopover') }}</p>
              </template>
              <Icon name="wenhao-tianchong" style="color: #ccc7d9" />
            </a-popover>
          </template>
        </template>
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'Publisher'">
            <div class="publisher-info">
              <LogoImage
                :logoUrl="record.publicImage"
                :brandName="record.creatorName"
              />
              <span>{{ record.creatorName }}</span>
            </div>
          </template>
          <template v-if="column.dataIndex === 'amazonBrandName'">
            <AutoTooltip
              :content="`${record.amazonBrandName} ${
                record.hasDuplicate
                  ? `(${record.amazonProfileAccountInfoName})`
                  : ''
              }`"
              :width="180"
            />
          </template>
          <template v-if="column.dataIndex === 'nextMonthCommission'">
            <div
              :style="{
                color: record?.nextMonthCommissionDetail?.commissionRate
                  ? ''
                  : 'rgba(15, 6, 41, 0.3)',
              }"
            >
              {{
                record?.nextMonthCommissionDetail?.commissionRate
                  ? record.nextMonthCommissionDetail.commissionRate + '%'
                  : '--'
              }}
            </div>
          </template>
          <template v-if="column.key === 'commission'">
            <div>{{ returnAttributionCommission(record) }}</div>
            <div class="time" v-if="record.timeMonthCommission">
              <a-popover placement="bottom">
                <template #content>
                  <div class="contentBox">
                    <p class="popoverContent">
                      {{
                        $t('seller.publishersPage.commissionChangeNotice', {
                          rate: returnAttributionCommissionBottom(record),
                          date: record.timeMonthCommission,
                        })
                      }}
                    </p>
                    <div
                      class="cancelBtn"
                      @click="cancelBrand(record, 'commissionChangeOperations')"
                    >
                      {{ $t('seller.common.cancel') }}
                    </div>
                  </div>
                </template>
                <template #title>
                  <span></span>
                </template>
                <div class="time-mid">
                  <Icon name="Frame" />
                  <span class="time-month">{{
                    $t('seller.publishersPage.commissionPreviewFromDate', {
                      rate: returnAttributionCommissionBottom(record),
                      date: record.timeMonthCommission,
                    })
                  }}</span>
                  <Icon name="a-error-tianchong5" class="close-icon" />
                </div>
              </a-popover>
            </div>
          </template>
          <template v-if="column.dataIndex === 'status'">
            <Status
              :text="record.status === 'active' ? $t('seller.brandsPage.partnershipPartnered') : $t('seller.brandsPage.partnershipNotPartnered')"
              :noBorder="true"
              :type="record.status"
              style="width: auto"
            />
          </template>

          <template v-if="column.dataIndex === 'collaborationPeriod'">
            <div
              :style="{
                color:
                  record?.startDateStr && record?.endDateStr
                    ? ''
                    : 'rgba(15, 6, 41, 0.3)',
              }"
            >
              {{
                record.startDateStr && record.endDateStr
                  ? record.startDateStr + ' ~ ' + record.endDateStr
                  : '--'
              }}
            </div>
          </template>

          <template v-if="column.dataIndex === 'action'">
            <div class="action-buttons" ref="actionButtonsRef">
              <!-- <artmisads-select-button
                style="margin-bottom: 10px"
                @click="handleEdit(record)"
              >
                Set Up Associate Partnership
              </artmisads-select-button> -->
              <artmisads-select-button @click="handleHistory(record)">
                {{ $t('seller.publishersPage.viewPartnershipHistory') }}
              </artmisads-select-button>
            </div>
          </template>
        </template>
      </artmisads-table>
    </div>
    <!-- Modals -->
    <history-model ref="historyModelRef" />
    <edit-modal ref="editModalRef" @refresh="onRefresh" />
  </div>
</template>

<script setup lang="jsx">
import { ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { publishersApi } from '@/server'
import buttonGroups from '~/components/buttonGroups.vue'
import Status from '~/components/Status.vue'
import HistoryModel from '~/components/historyModel.vue'
import EditModal from '@/pages/seller/Publishers/components/editModal.vue'
import Icon from '@/components/Icon.vue'
import LogoImage from '~/components/LogoImage.vue'
import AutoTooltip from '~/components/AutoTooltip.vue'
import { countBrandNames } from '~/utils'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
import SvgIcon from '~/components/SvgIcon.vue'
import { useRouter } from 'vue-router'
import moment from 'moment'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'
import { useUserInfoStore } from '@/storeData'
import { brandApi } from '@/server'
import { message } from 'ant-design-vue'

const { t } = useI18n()
const user = useUserInfoStore()
const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode]

// Props
const props = defineProps({
  publisherId: {
    type: String,
    required: true,
  },
  brandId: {
    type: String,
    default: '',
  },
  associateEnabled: {
    type: Boolean,
    default: true,
  },
  creatorName: {
    type: String,
    default: '',
  },
})
const dropDownLoading = ref(false)
const selectedRowKeys = ref([])
const activeSelectedRowKeys = ref([])
const inactiveSelectedRowKeys = ref([])
const router = useRouter()
// 新增：跨页选择状态管理
const allSelectedRowKeys = ref(new Set()) // 存储所有页面的选择状态
const allSelectedRows = ref(new Map()) // 存储所有页面的选择行数据

const onSelectChange = (newSelectedRowKeys, selectedRows) => {
  // 更新当前页的选择状态
  selectedRowKeys.value = newSelectedRowKeys

  // 更新全局选择状态
  const currentPageIds = data.value.map((item) => item.id)

  // 移除当前页之前的选择状态
  currentPageIds.forEach((id) => {
    allSelectedRowKeys.value.delete(id)
    allSelectedRows.value.delete(id)
  })

  // 添加当前页新的选择状态
  newSelectedRowKeys.forEach((key) => {
    allSelectedRowKeys.value.add(key)
    const row = selectedRows.find((item) => item.id === key)
    if (row) {
      allSelectedRows.value.set(key, row)
    }
  })

  // 更新状态分类的选择
  updateStatusBasedSelection()
}

// 更新基于状态的选择分类
const updateStatusBasedSelection = () => {
  const allSelectedRowsArray = Array.from(allSelectedRows.value.values())
  activeSelectedRowKeys.value = allSelectedRowsArray.filter(
    (item) => item.status === 'active',
  )
  inactiveSelectedRowKeys.value = allSelectedRowsArray.filter(
    (item) => item.status === 'inactive',
  )
}

// 设置当前页的勾选状态
const setCurrentPageSelection = () => {
  // 根据全局选择状态设置当前页的勾选状态
  const currentPageSelectedKeys = data.value
    .filter((item) => allSelectedRowKeys.value.has(item.id))
    .map((item) => item.id)

  selectedRowKeys.value = currentPageSelectedKeys
}

const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table',
  bottomSpace: 100,
  minHeight: 600,
  maxHeight: 1000,
  defaultHeight: 600,
})
const columns = computed(() => {
  const firstCol = props.brandId
    ? {
        title: t('seller.brandsPage.colPublisher'),
        dataIndex: 'Publisher',
        width: 200,
        align: 'center',
      }
    : {
        title: t('seller.brandsPage.colBrandName'),
        dataIndex: 'amazonBrandName',
        minWidth: 250,
        showTooltip: true,
        align: 'center',
        fixed: 'left',
      }
  return [
    firstCol,
    {
      title: t('seller.publishersPage.activeCommission'),
      dataIndex: 'commissionRate',
      key: 'commission',
      width: 200,
      align: 'center',
    },
    {
      title: t('seller.brandsPage.colPartnershipStatus'),
      dataIndex: 'status',
      align: 'center',
    },
    {
      title: t('seller.brandsPage.collaborationPeriod'),
      dataIndex: 'collaborationPeriod',
      align: 'center',
    },
    {
      title: t('seller.brandsPage.colActionsTable'),
      dataIndex: 'action',
      align: 'center',
      minWidth: 550,
      fixed: 'right',
    },
  ]
})

// Reactive data
const data = ref([])
const loading = ref(false)
const tableTotal = ref(0)
const params = ref({
  page: 1,
  size: 10,
  keyword: '',
  partnershipStatus: '',
})
const keyword = ref('')
const partnershipStatus = ref('')

// Refs
const historyModelRef = ref(null)
const editModalRef = ref(null)

// 定义 emit
const emit = defineEmits(['data-loaded'])
const returnAttributionCommissionBottom = (record) => {
  if (!record?.pendingOperations?.length) return ''
  try {
    const parsed = JSON.parse(record.pendingOperations[0].changeTo)
    const rate = parsed.commissionRate ?? parsed.commission_rate
    if (rate != null && rate !== '') {
      return `${rate}%`
    }
  } catch (e) {
    // ignore invalid changeTo
  }
  return ''
}
const returnAttributionCommission = (record) => {
  let str = ''
  if (record?.currentCommissionDetail) {
    if (Object.keys(record?.currentCommissionDetail).length) {
      str = record?.currentCommissionDetail?.commissionRate + '%'
    }
  } else {
    str = '--'
  }
  return str
}
// API Methods
const getData = () => {
  loading.value = true
  if (props.publisherId) {
    const requestParams = {
      publisherId: props.publisherId,
      ...params.value,
    }
    publishersApi
      .getPublisherDetail(requestParams)
      .then((res) => {
        if (res.success) {
          tableTotal.value = res.data.total
          const brandNameCount = countBrandNames(
            res.data?.data,
            'brandVO.amazonBrandName',
          )
          data.value = res.data?.data?.map((item, index) => {
            return {
              ...item.brandVO,
              currentCommissionDetail: item.currentCommissionDetail,
              pendingOperations: item.pendingOperations,
              nextMonthCommissionDetail: item.nextMonthCommissionDetail,
              status: item.status,
              startDateStr: item.startDateStr,
              endDateStr: item.endDateStr,
              publisherId: item.publisherId,
              brandId: item.brandId,
              commissionRate: item?.currentCommissionDetail?.commissionRate,
              lastCommissionRate: item?.lastCommissionRate,
              hasDuplicate:
                item.brandVO.amazonBrandName &&
                brandNameCount[item.brandVO.amazonBrandName] > 1,
            }
          })
          data.value.forEach((item) => {
            if (item.pendingOperations?.length) {
              item.timeMonthCommission = moment(
                item.pendingOperations[0].effectiveTime,
              )
                .tz(timezone)
                .format('MM/DD')
              item.timeMonthNameCommission = moment(
                item.pendingOperations[0].effectiveTime,
              )
                .tz(timezone)
                .format('MMM DD,YYYY')
              item.timeMonthNameAllCommission = moment(
                item.pendingOperations[0].effectiveTime,
              )
                .tz(timezone)
                .format('MMMM DD,YYYY')
            }
          })
          // 数据加载完成后恢复勾选状态
          setTimeout(() => {
            setCurrentPageSelection()
            emit('data-loaded', data.value)
          }, 200)
        }
      })
      .finally(() => {
        loading.value = false
      })
  }
  if (props.brandId) {
    const requestParams = {
      brandId: props.brandId,
      ...params.value,
    }
    publishersApi
      .getPublisherDetailByBrandId(requestParams)
      .then((res) => {
        if (res.success) {
          tableTotal.value = res.data.total
          data.value = res.data.data.map((item, index) => {
            return {
              ...item.brandVO,
              id: item.publisherId || `publisher_${index}`, // 确保每行有唯一ID
              nextMonthCommissionDetail: item.nextMonthCommissionDetail,
              status: item.status,
              startDateStr: item.startDateStr,
              endDateStr: item.endDateStr,
              publisherId: item.publisherId,
              brandId: item.brandId,
              publicImage: item.publicImage,
              creatorName: item.creatorName,
              commissionRate: item?.currentCommissionDetail?.commissionRate,
              lastCommissionRate: item?.lastCommissionRate,
            }
          })
          // 数据加载完成后恢复勾选状态
          setTimeout(() => {
            setCurrentPageSelection()
            emit('data-loaded')
          }, 200)
        }
      })
      .finally(() => {
        loading.value = false
      })
  }
}
const handleMenuClick = (event) => {
  if (event.key === 'activeBrands') {
    const record = {
      status: 'active',
      type: 'multi',
      brandList: activeSelectedRowKeys.value,
    }
    editModalRef.value?.showModal(record)
  }
  if (event.key === 'inactiveBrands') {
    const record = {
      status: 'inactive',
      type: 'multi',
      brandList: inactiveSelectedRowKeys.value,
    }
    editModalRef.value?.showModal(record)
  }
}
// Event handlers
const handlePageChange = (page, pageSize) => {
  params.value.page = page
  // 翻页时不清空选择状态，保留之前的选择
  getData()
}

const handleSearch = () => {
  params.value.keyword = keyword.value
  params.value.page = 1
  params.value.size = 10
  // 搜索时清空所有选择状态
  clearAllSelection()
  getData()
}
const handleRule = () => {
  router.push({
    path: `/seller/commission-rule`,
    query: {
      publisherId: props.publisherId,
      creatorName: props.creatorName,
    },
  })
  //  window.open(`/seller/commission-rule/${props.publisherId}`, '_blank')
}
const handleStatusChange = (value) => {
  params.value.partnershipStatus = value
  partnershipStatus.value = value
  params.value.page = 1
  params.value.size = 10
  // 状态筛选时清空所有选择状态
  clearAllSelection()
  getData()
}

const handleEdit = (record) => {
  let param = {}
  if (props.brandId) {
    param = {
      ...record,
      brandId: props.brandId,
    }
  } else {
    param = {
      ...record,
    }
  }

  editModalRef.value?.showModal(param)
}

const handleHistory = (record) => {
  let param = {}
  if (props.brandId) {
    param = {
      ...record,
      brandId: props.brandId,
    }
  } else {
    param = {
      ...record,
    }
  }

  historyModelRef.value?.showModal(param, 'publishers')
}

const handleChangePage = ({ current, pageSize }) => {
  params.value.page = current
  params.value.size = pageSize
  // 翻页时不清空选择状态，保留之前的选择
  getData()
}

// 清空所有选择状态
const clearAllSelection = () => {
  selectedRowKeys.value = []
  activeSelectedRowKeys.value = []
  inactiveSelectedRowKeys.value = []
  allSelectedRowKeys.value.clear()
  allSelectedRows.value.clear()
}

const onRefresh = () => {
  getData()
  clearAllSelection()
}
const cancelBrand = async (record, type) => {
  const data = await brandApi.cancelTask({
    operationId: record.pendingOperations[0].operationId,
  })
  if (data.success) {
    message.success(t('seller.msg.cancelSuccess'), 1)
    getData()
  }
}
// Watch for prop changes
watch(
  [() => props.publisherId, () => props.brandId],
  ([newPublisherId, newBrandId], [oldPublisherId, oldBrandId]) => {
    params.value.page = 1
    params.value.size = 10
    params.value.keyword = ''
    params.value.partnershipStatus = ''
    keyword.value = ''
    partnershipStatus.value = ''
    // props 变化时清空所有选择状态
    clearAllSelection()
    getData()
  },
  { immediate: true },
)
defineExpose({
  data,
  getAllActionButtonsRefs: () => {
    return document.querySelectorAll('.action-buttons')
  },
})
// Lifecycle
// onMounted(() => {
//   getData()
// })
</script>

<style scoped lang="less">
.cancelBtn {
  cursor: pointer;
  margin-top: 10px;
  max-width: 70px;
  font-family: Sora;
  font-weight: 500;
  font-size: 13px;
  color: rgba(235, 78, 61, 1);
  line-height: 18px;
  letter-spacing: 0.3px;
  padding: 3px 11px;
  text-align: center;
  background-color: rgba(254, 238, 236, 1);
  border: 1px solid rgba(245, 119, 105, 1);
  border-radius: 6px;
}
.close-icon {
  width: 18px;
  height: 18px;
  color: rgba(15, 6, 41, 0.2);
}
.time {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(245, 246, 247, 1);
  border-radius: 6px;
  padding: 4px 8px;
  margin-top: 10px;
  .time-mid {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}
.artmisads-select-down-icon {
  width: 14px;
  height: 14px;
  vertical-align: -1px;
  fill: var(--dark-4);
}

.actions-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .action-num {
    display: flex;
    align-items: center;
  }
}
.brand-font {
  word-break: break-all;
  flex: 1;
  margin-left: 12px;
  font-weight: 500;
  color: var(--dark-1);
  letter-spacing: 0.4px;
  line-height: 22px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  // text-decoration: underline;
}

.publisher-info {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 200px;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.publisher-associate-table {
  .table-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    height: 64px;

    .filters {
      display: flex;
      align-items: center;
      gap: 12px;

      .statusFilter {
        display: flex;
        align-items: center;
        white-space: nowrap;
        position: relative;
        z-index: 2;
        margin-left: 18px;
        font-family: Sora, sans-serif;
        font-weight: 400;
        font-size: 14px;
        color: var(--dark-2);
        letter-spacing: 0.4px;
        line-height: 20px;

        span {
          color: rgba(15, 6, 41, 0.8);
          font-weight: 500;
        }
      }
    }
  }
}
</style>
